/**
 * IconButton Component
 *
 * Abstraction layer over MUI IconButton.
 */

import { IconButtonProps, IconButton as MuiIconButton } from '@mui/material';
import React from 'react';

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  return <MuiIconButton ref={ref} {...props} />;
});

IconButton.displayName = 'IconButton';

export default IconButton;
